var React = require('react');

function FilterFilled (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/filter filled"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":3},React.createElement("g",{"id":"icon/filter-filled"},[React.createElement("polygon",{"id":"Line","stroke":"#21ABF3","fill":"#21ABF3","points":"17.4599991 5.5 12.5751616 11.5347664 7.4000001 5.5","key":0}),React.createElement("polygon",{"id":"Line","stroke":"#333333","points":"20.6574067 4 13.6687856 12.7409659 13.6687856 19.1700001 11.4116672 19.1700001 11.4116672 12.7409659 4 4","key":1})]))]);
}

FilterFilled.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = FilterFilled;

FilterFilled.default = FilterFilled;
